import EvAlert from '../components/EvAlert';
import { mountComponent } from './componentMount';

export function Message(methodOptions = null, anchorElement = null) {
  this.options = methodOptions ? { ...methodOptions } : { toggle: false };
  this.anchorElement = anchorElement;

  this.setOption = (options) => {
    this.options = { ...options };
  };

  this.renderType = (type, message) => {
    this.options = { ...this.options, type, message };
    return this._render();
  };

  this.success = (message) => this.renderType('success', message);
  this.info = (message) => this.renderType('info', message);
  this.error = (message) => this.renderType('error', message);
  this.warning = (message) => this.renderType('warning', message);

  this._render = () => {
    let mountedComponent;
    const options = {
      ...this.options,
      message: this.options.message ?? this.options.content,
      onClosed: () => mountedComponent.unmount()
    };

    mountedComponent = mountComponent(EvAlert, options);
    const element = mountedComponent.component.$el;
    const items = document.getElementsByClassName('ev-alert');

    if (items.length > 1 && !this.options.floating) {
      const previous = items[items.length - 2];
      element.style.top = `${previous.clientHeight + previous.offsetTop}px`;
    } else if (!this.options.floating) {
      element.style.top = '110px';
    }

    if (this.options.floating && this.anchorElement) {
      const rect = this.anchorElement.getBoundingClientRect();
      element.style.top = `${rect.bottom}px`;
      element.style.left = `${rect.left}px`;
    }

    return mountedComponent.component;
  };
}

function showMessage(options, anchorElement = null) {
  const message = new Message(options, anchorElement);
  return message._render();
}

function createMessageFacade(anchorElement = null) {
  const facade = (options) => showMessage(options, anchorElement);
  facade.error = (message) => showMessage({ type: 'error', message }, anchorElement);
  facade.success = (message) => showMessage({ type: 'success', message }, anchorElement);
  facade.info = (message) => showMessage({ type: 'info', message }, anchorElement);
  facade.warning = (message) => showMessage({ type: 'warning', message }, anchorElement);
  return facade;
}

const staticMessage = createMessageFacade();

export const messenger = {
  $message: staticMessage,
  error: staticMessage.error,
  success: staticMessage.success,
  info: staticMessage.info,
  warning: staticMessage.warning,
  $alert(message) {
    return staticMessage.warning(message);
  }
};

export default {
  install(app) {
    const message = function (options) {
      return showMessage(options, this?.$el || null);
    };
    message.error = staticMessage.error;
    message.success = staticMessage.success;
    message.info = staticMessage.info;
    message.warning = staticMessage.warning;

    app.config.globalProperties.$message = message;
    app.config.globalProperties.$alert = messenger.$alert;
  }
};
